import defaultValues from './defaultValues'

const invalid = JSON.parse(defaultValues);

export default invalid;